import * as React from 'react'

import { Link } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import configurator from 'modules/app_store/lib/SubscriptionAddonConfigurator'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

interface Props {
  subscriptionAddon: SubscriptionAddon
}

const ContactLink = ({ subscriptionAddon }: Props) => {
  const { navigation } = useNavigation()
  const contactLink = configurator.contactLink(subscriptionAddon, navigation)

  if (!contactLink) return null

  return (
    <Link.Href target="_blank" rel="noopener noreferrer" href={`mailto:${contactLink}`}>
      {i18n.t('app_store_v2.common.contact_support')}
    </Link.Href>
  )
}

export default ContactLink
